module.exports = __webpack_public_path__ + "img/Group 59@2x.571684a0.png";